import * as React from "react";
const SvgFiRrFaceZany = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-zany_svg__a)">
      <path
        fill="#062147"
        d="M18.997 14.071a1.001 1.001 0 0 0-1.718-.765c-3.179 3.302-8.296 3.692-8.347 3.696a1 1 0 0 0-.933.998v1.6c0 1.635 1.147 3.4 3 3.4 1.771 0 2.897-1.612 2.993-3.182 3.676-.949 4.888-4.104 5.005-5.747M12 19.6c0 .662-.411 1.4-1 1.4s-1-.738-1-1.4v-.713a18 18 0 0 0 2-.426zM7 14a2 2 0 1 1-.001-3.999A2 2 0 0 1 7 14m11-5.5C18 6.57 16.43 5 14.5 5S11 6.57 11 8.5s1.57 3.5 3.5 3.5S18 10.43 18 8.5m-5 0c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5-.673 1.5-1.5 1.5S13 9.327 13 8.5M24 12c0 4.981-2.997 9.37-7.637 11.182a1.003 1.003 0 0 1-1.295-.568 1 1 0 0 1 .568-1.295 9.94 9.94 0 0 0 6.363-9.318c0-5.514-4.486-10-10-10S2 6.486 2 12a9.97 9.97 0 0 0 3.637 7.715 1 1 0 0 1-1.273 1.542A11.97 11.97 0 0 1 0 12C0 5.383 5.383 0 12 0s12 5.383 12 12"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-zany_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceZany;
